import { ReactNode, useContext, useId } from 'react'
import { MenuContext } from './context/menu-context'
import { MenuKey } from './desktop'
import { generateDropdownClipPath } from './generate-dropdown-clip-path'

type Props = {
    children: ReactNode
    caretPosition: number | null
    gradient?: string
    title: string
    menuItemKey: MenuKey
}

export const DropDownContainer = ({ children, caretPosition, gradient, title, menuItemKey }: Props) => {
    const clipId = useId().replace(/:/g, '')
    const { handleMouseEnter, handleMouseLeave } = useContext(MenuContext)

    if (caretPosition === null || !gradient) return null

    const CARET_WIDTH = 26
    const CARET_HEIGHT = 12
    const CONTAINER_WIDTH = 1041
    const BORDER_RADIUS = 6
    const CONTAINER_HEIGHT = title === 'Reactions' ? 368 : title === 'Categories' ? 338 : 368
    const TOTAL_HEIGHT = CONTAINER_HEIGHT + CARET_HEIGHT

    const scrollbarOffset =
        typeof window !== 'undefined' && window.innerWidth > document.documentElement.clientWidth ? 7 : 0
    const adjustedCaretPosition = caretPosition + scrollbarOffset

    const pathData = generateDropdownClipPath({
        width: CONTAINER_WIDTH,
        totalHeight: TOTAL_HEIGHT,
        caretHeight: CARET_HEIGHT,
        caretWidth: CARET_WIDTH,
        caretPosition: adjustedCaretPosition,
        borderRadius: BORDER_RADIUS,
    })

    return (
        <div
            onMouseEnter={() => handleMouseEnter(menuItemKey)}
            onMouseLeave={() => {
                handleMouseLeave()
            }}
            className={`pointer-events-none absolute top-full z-modalAlert translate-px justify-center`}
        >
            <svg width="0" height="0" className="absolute">
                <defs>
                    <clipPath id={clipId}>
                        <path d={pathData} />
                    </clipPath>
                </defs>
            </svg>
            <div className="relative mx-auto">
                <div
                    style={{
                        width: `${CONTAINER_WIDTH}px`,
                        height: `${TOTAL_HEIGHT}px`,
                        background: gradient,
                        clipPath: `url(#${clipId})`,
                        WebkitClipPath: `url(#${clipId})`,
                    }}
                    className="pointer-events-auto"
                >
                    <div style={{ paddingTop: `${CARET_HEIGHT}px` }} className="box-border h-full">
                        <div className="h-full text-white">{children}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
